import React from 'react';
import { Modal, Button, Typography, Space, Spin, Empty, Tag } from 'antd';
import {
    UserOutlined, ClockCircleOutlined, LinkOutlined,
    EyeFilled, MessageOutlined, CloudDownloadOutlined
} from '@ant-design/icons';
import { CommunityPostDetail } from '../../../services/dashboardService';

const { Title, Text } = Typography;

interface PostDetailModalProps {
    visible: boolean;
    onCancel: () => void;
    loading: boolean;
    post: CommunityPostDetail | null;
    onScrape: (id: number) => void;
}

export const PostDetailModal: React.FC<PostDetailModalProps> = ({
    visible,
    onCancel,
    loading,
    post,
    onScrape
}) => {
    // Helper for status tag (duplicated for isolation or could be shared)
    const getStatusTag = (status: string) => {
        switch (status) {
            case 'scraped': return <Tag color="success">已抓取</Tag>;
            case 'pending': return <Tag color="warning">待抓取</Tag>;
            case 'failed': return <Tag color="error">失败</Tag>;
            default: return <Tag>{status}</Tag>;
        }
    };

    return (
        <Modal
            title={
                <div className="post-detail-header">
                    <Title level={4} style={{ margin: 0 }}>{post?.title}</Title>
                    <div className="post-detail-meta">
                        <Text type="secondary">
                            <UserOutlined style={{ marginRight: 4 }} />
                            {post?.author}
                        </Text>
                        <Text type="secondary" style={{ marginLeft: 16 }}>
                            <ClockCircleOutlined style={{ marginRight: 4 }} />
                            {post?.time}
                        </Text>
                    </div>
                </div>
            }
            open={visible}
            onCancel={onCancel}
            width={900}
            footer={
                <Space>
                    <Button href={post?.url} target="_blank" icon={<LinkOutlined />}>
                        访问原文
                    </Button>
                    <Button onClick={onCancel}>关闭</Button>
                </Space>
            }
        >
            {loading ? (
                <div className="post-detail-loading">
                    <Spin size="large" />
                    <Text type="secondary" style={{ marginTop: 16 }}>正在加载内容...</Text>
                </div>
            ) : post ? (
                <div className="post-detail-content">
                    {/* 统计信息 */}
                    <div className="post-stats-bar">
                        <Space size="large">
                            <Text><EyeFilled style={{ marginRight: 4 }} />{post.view_count} 浏览</Text>
                            <Text><MessageOutlined style={{ marginRight: 4 }} />{post.reply_count} 回复</Text>
                            <Text><UserOutlined style={{ marginRight: 4 }} />{post.follow_count} 关注</Text>
                        </Space>
                        {getStatusTag(post.scrape_status)}
                    </div>

                    {/* 内容区域 */}
                    {post.content_html ? (
                        <>
                            <div className="post-html-content" dangerouslySetInnerHTML={{ __html: post.content_html }} />
                            {post.replies_html && (
                                <>
                                    <div style={{ margin: '20px 0', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                                        <Title level={5}>评论 / 回复</Title>
                                    </div>
                                    <div className="post-replies-content" dangerouslySetInnerHTML={{ __html: post.replies_html }} />
                                </>
                            )}
                        </>
                    ) : post.scrape_status === 'pending' ? (
                        <Empty description="内容尚未抓取" image={Empty.PRESENTED_IMAGE_SIMPLE}>
                            <Button type="primary" icon={<CloudDownloadOutlined />} onClick={() => onScrape(post.id)}>
                                立即抓取
                            </Button>
                        </Empty>
                    ) : (
                        <Empty description={post.scrape_error || "抓取失败"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )}
                </div>
            ) : (
                <Empty description="无内容" />
            )}
        </Modal>
    );
};
